import React from 'react';
import './uber2.css';
import { AREAS, AREAS_OBJ, AREA_IDS } from './model/areas';
import ApiController from './controller/ApiController';
import { FINALISTS, SHORTLIST } from './model/shortlist';

/**
 * @author Carl Trelfa
 */

const NOMINEES_PER_ROW = 4;
const NOMINEES_PER_ROW_1350 = 3;
const NOMINEES_PER_ROW_840 = 2;
const NOMINEES_PER_ROW_410 = 1;

const USE_PLACE_HOLDER_DATA = true;

export default class FinalistsPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            nomineesPerRow: NOMINEES_PER_ROW,
            shortlistFetched: false,
            shortList: null,
        }
    }

    componentDidMount() {      
        let perRow = this.workOutNomineesPerRow();
        if (this.state.nomineesPerRow !== perRow) {
            this.setState({nomineesPerRow: perRow});
        }

        if (!this.state.shortlistFetched) {
            this.fetchShortlist();
        }

        window.addEventListener('resize', this.resizeHandler);
    }

    resizeHandler = () => {
        let perRow = this.workOutNomineesPerRow();
        if (this.state.nomineesPerRow !== perRow) {
            this.setState({nomineesPerRow: perRow});
        }
    }

    fetchShortlist = () => { 
        if (!USE_PLACE_HOLDER_DATA) {
            // ApiController.FetchRestaurants(this.parseRestaurantData);
            this.parseRestaurantData({response: SHORTLIST});
        } else {
            this.parseRestaurantData({response: SHORTLIST});
        }
    }

    parseRestaurantData = (data) => {
        let finalists = [];
        for (let i = 0; i < FINALISTS.length; i++) {
            for (let j = 0; j < data.response.length; j++) {
                if (USE_PLACE_HOLDER_DATA ? j + 1 == FINALISTS[i] : data.response[j].restaurant_id == FINALISTS[i]) {
                    let r = {
                        id: USE_PLACE_HOLDER_DATA ? j + 1 : data.response[j].restaurant_id,
                        name: USE_PLACE_HOLDER_DATA ? data.response[j].name : data.response[j].restaurant_name,
                        area: USE_PLACE_HOLDER_DATA ? data.response[j].area : data.response[j].region_id,
                        image: USE_PLACE_HOLDER_DATA ? data.response[j].area + '/' + data.response[j].image : data.response[j].region_id + '/' + data.response[j].restaurant_image,
                    }
                    finalists.push(r);
                    break;
                }
            }
        }

        console.log('Finalists: ', data, finalists);

        this.setState({
            shortlistFetched: true,
            shortList: finalists,
        });
    }

    workOutNomineesPerRow = () => {
        let perRow = NOMINEES_PER_ROW;
        if (window.innerWidth < 410) {
            perRow = NOMINEES_PER_ROW_410;
        } else
        if (window.innerWidth < 840) {
            perRow = NOMINEES_PER_ROW_840;
        } else
        if (window.innerWidth < 1350) {
            perRow = NOMINEES_PER_ROW_1350;
        }
        return perRow;
    }

    render() {
        let finalistRows = [[]];
        if (this.state.shortlistFetched) {
            let row = 0;
            let inRowCount = 0;
            for (let i = 0; i < this.state.shortList.length; i++) {
                finalistRows[row].push(this.state.shortList[i]);
                inRowCount++;
                if (inRowCount === this.state.nomineesPerRow && i < this.state.shortList.length - 1) {
                    inRowCount = 0;
                    row++;
                    finalistRows.push([]);
                }
            }
            while(finalistRows[row].length < this.state.nomineesPerRow) {
                finalistRows[row].push({});
            }
            console.log('Finalist Rows: ', finalistRows);
        }

        return (
            <div className="split-page-holder-vote">
                <div className="page-split-left-vote"><div className="left-content-holder-vote">

                    <div className='small-screen-content-holder'>
                        <div className="nom-header">
                            <img className="uber-eats-logo-vote" src='./uber-assets/UE_Logo_Horizontal_RGB_web_GreenBG.svg' />
                        </div>
                        <h2>Uber Eats presents<br/>The Restaurant of the Year</h2>
                        <h1>Congratulations to the regional finalists.</h1>
                        <p>Congratulations to the finalists of the Uber Eats Restaurant Awards 2023, who will now be invited to create their dishes for a panel of specialist judges including Prue Leith and Monica Galetti. The overall winner will be announced in October and will receive a £100,000 prize to invest in their restaurant, so stay tuned.</p>
                        <p>&nbsp;</p>
                    </div>
                {this.state.shortlistFetched &&
                <>
                    <hr />

                    <div className='small-screen-content-holder'>

                    {
                        finalistRows.map(
                            (item, index) => {
                                return (
                                    <div className='nominee-row' key={'nr_' + index}>
                                        {
                                            item.map(
                                                (item2, index2) => {
                                                    return (
                                                        <>
                                                            <div className='nominee-holder' key={'nr_' + index + 'nh_' + index2}>
                                                                <p className='area-small'>{AREAS_OBJ[item2.area]}</p>
                                                                {item2.name &&
                                                                    <>
                                                                        <div className='nominee-name'>
                                                                            <p dangerouslySetInnerHTML={{ __html: item2.name }}></p>
                                                                        </div>
                                                                        <div className='nominee-pic-holder'>
                                                                            <div className='nominee-pic' style={{ backgroundImage: 'url(' + (item2.image != '' ? ('./uber-assets/restaurant_imgs/' + item2.image) : './restaurantPlaceholder.jpg') + ')', backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>

                                                                            </div>
                                                                            <div className='finalist-badge'></div>
                                                                        </div>
                                                                    </>
                                                                }
                                                            </div>
                                                            {
                                                                index2 < this.state.nomineesPerRow - 1 && <div className='nominee-spacer'></div>
                                                            }
                                                        </>
                                                    )
                                                }
                                            )
                                        }
                                    </div>
                                );
                            }
                        )
                    }

                    </div>
                </>
                }


                    <div className='shrink'>
                        <hr />
                        <div className='small-screen-content-holder'>
                            <p className="form-label">All submitted data will be treated in accordance with our <a href="https://uber.com/legal" target="_blank">Privacy Policy</a>.</p>
                            <p className="form-label">Restaurant of the Year 2023 <a href="https://www.dropbox.com/s/b3841vdz83yp5bs/T%26Cs%20-%20Awards.pdf?dl=0" target="_blank">Terms and Conditions</a>.</p>
                            <p>&nbsp;</p>
                            <p className="form-label">&#169; 2023 Uber Technologies Inc.</p>
                        </div>
                    </div>

                    </div></div>
                    
                <div className="page-split-right-vote">
                </div>
            </div>
        );
                }

 }